(function () {

    var StartEVerifyComponent = {
        bindings: {
            modalData: '<',
            hide: '&',
            everifyUtils: '<',
            checkDuplicate: '&'
        },
        templateUrl: '../modules/e-verify/components/start-e-verify/start-e-verify.html',
        controllerAs: 'startEVerify',
        controller: ['$scope', function ($scope) {

            var self = this;

            // private attribute needed to load start case modal
            var brand;
            var application_id;
            var prospect_id;
            var job;
            var defaultDocument;
            var document;

            // private functions used on the controller

            // simple error handler to through
            var _startEVerifyErrorHandle = function (message) {
                this.message = message;
                this.name = 'Start E-Verify Error';
            };

            var _handleStartSectionsChange = function () {
                var promises = {};

                // this promise to finish or show a new section
                var defer = $q.defer();

                delete self.sectionCode;
                delete self.sectionSrc;
                delete self.formValidation;

                if (
                    self.everifyStartStatus.is_receipt &&
                    !self.everifyStartStatus.done_is_receipt
                ) {
                    self.sectionCode = "UNACCEPTABLE_RECEIPTS";
                    self.sectionSrc = "../modules/e-verify/components/start-e-verify/sections/unacceptable-receipts.html";

                    self.everifyStartStatus.done_is_receipt = true;
                } else if (!self.everifyStartStatus.valid_selection) {
                    self.sectionCode = "INVALID_LIST_B_SELECTION";
                    self.sectionSrc = "../modules/e-verify/components/start-e-verify/sections/invalid-list-b-selection.html";
                } else if (
                    !self.everifyStartStatus.ssn_found &&
                    !self.everifyStartStatus.done_no_ssn_found
                ) {
                    self.sectionCode = "NO_SSN";
                    self.sectionSrc = "../modules/e-verify/components/start-e-verify/sections/no-ssn.html";

                    self.everifyStartStatus.done_no_ssn_found = true;
                } else if (
                    self.everifyStartStatus.hire_date_past_due &&
                    !self.everifyStartStatus.done_hire_date_past_due
                ) {
                    if (!self.everifyStartStatus.done_hire_date_past_due_first_section) {
                        self.sectionCode = "VALID_I9";
                        self.sectionSrc = "../modules/e-verify/components/start-e-verify/sections/valid-i9.html";

                        self.formValidation = self.everifyUtils.getFormValidation($scope, 'valid-i9-form');
                        self.everifyStartStatus.done_hire_date_past_due_first_section = true;
                    } else {
                        self.sectionCode = "LATE_HIRE";
                        self.sectionSrc = "../modules/e-verify/components/start-e-verify/sections/late-verification.html";

                        self.formValidation = self.everifyUtils.getFormValidation($scope, 'late-verify-form');
                        self.data.hire_date = self.everifyStartStatus.hire_date;

                        // loading why here
                        promises['late_reasons'] = EVerifyAPI.getLateVerificationReasons();

                        self.everifyStartStatus.done_hire_date_past_due = true;
                    }
                } else if (
                    self.everifyStartStatus.alien_number_required &&
                    !self.everifyStartStatus.done_alien_number_requirede
                ) {
                    self.sectionCode = "ALIEN_NUMBER_REQUIRED";
                    self.sectionSrc = "../modules/e-verify/components/start-e-verify/sections/alien-number-required.html";

                    self.formValidation = self.everifyUtils.getFormValidation($scope, 'align-number-form');

                    self.everifyStartStatus.done_alien_number_requirede = true;
                } else if (
                    self.everifyStartStatus.ssn_found &&
                    !self.everifyStartStatus.hire_date_past_due &&
                    !self.everifyStartStatus.alien_number_required &&
                    !self.everifyStartStatus.done_ssn_found
                ) {
                    self.sectionCode = "VALID_I9";
                    self.sectionSrc = "../modules/e-verify/components/start-e-verify/sections/valid-i9.html";

                    self.formValidation = self.everifyUtils.getFormValidation($scope, 'valid-i9-form');
                    self.everifyStartStatus.done_ssn_found = true;
                }

                $q.all(promises)
                    .then(function (neededData) {
                        var lateHireReasons = neededData.late_reasons;

                        if (lateHireReasons) {
                            self.lateHireReasons = lateHireReasons;
                        }

                        if (self.sectionCode) {
                            defer.reject({code: self.sectionCode});
                        } else {
                            defer.resolve({code: 'SUCCESS'});
                        }
                    }, function (err) {
                        self.everifyUtils.handleEVerifyErrorMessages(err, function () {
                            delete self.loading;
                            self.hide({statusCode: 'ERROR', data: err});
                        });

                        defer.reject({code: 'ERROR'});
                    });

                return defer.promise;
            };

            // Start the e-verify when everything is ok from the server
            self.startEVerify = function () {
                var validSending = true;
                self.starting = true;

                if (
                    self.formValidation &&
                    !self.formValidation.validator.validate()
                ) {
                    self.starting = false;
                    validSending = false;
                }

                if (validSending) {

                    self.loading = true;

                    _handleStartSectionsChange()
                        .then(function () {

                            if (
                                self.late_reasons !== 'LATE_HIRE_DT_RSN_OTHER' &&
                                !self.everifyStartStatus.hire_date_past_due
                            ) {
                                delete self.late_reason_other_txt;
                            }

                            if (!self.everifyStartStatus.alien_number_required) {
                                delete self.alien_number;
                            }

                            EVerifyAPI.getDuplicatesCases(brand.id, self.user.id, self.caseId)
                                .then(function (res) {
                                    self.duplicate_cases = res.cases || [];

                                    if (self.duplicate_cases.length) {
                                        var data = {
                                            late_reasons: self.late_reasons,
                                            late_reason_other_txt: self.late_reason_other_txt,
                                            alien_number: self.alien_number,
                                            phoneNumber: self.phoneNumber,
                                            duplicate_cases: self.duplicate_cases
                                        };

                                        self.checkDuplicate({data: data});
                                    } else {
                                        EVerifyAPI.startUserCase(
                                            brand.id,
                                            self.user.id,
                                            self.caseId,
                                            self.late_reasons,
                                            self.late_reason_other_txt,
                                            self.alien_number,
                                            self.phoneNumber
                                        ).then(function (data) {
                                            self.hide({statusCode: 'SUCCESS', data: data});
                                            delete self.starting;
                                            delete self.loading;
                                            $scope.$digest();
                                        }, function (err) {

                                            self.everifyUtils.handleEVerifyErrorMessages(err, function () {
                                                delete self.starting;
                                                delete self.loading;
                                                self.hide({statusCode: 'ERROR', data: err});
                                            });

                                            $scope.$digest();
                                        });
                                    }

                                })
                                .catch(function (err) {
                                    self.everifyUtils.handleEVerifyErrorMessages(err, function () {
                                        delete self.starting;
                                        delete self.loading;
                                        self.hide({statusCode: 'ERROR', data: err});
                                    });

                                    $scope.$digest();
                                });
                        }, function () {
                            setTimeout(function () {
                                delete self.starting;
                                delete self.loading;

                                $scope.$digest();
                            }, 200);
                        });
                }
            };

            // Resend the I9 document when its not allowed to start e-verify
            self.resendDocuments = function () {
                self.sending = true;

                var prospect = {
                    "user": self.user,
                    "brand_id": brand.id,
                    "job_id": job.id,
                    "position_id": job.Position.id
                };

                if (prospect_id) {
                    prospect.prospect_id = prospect_id;
                }
                else {
                    prospect.application_id = application_id;
                }

                OnBoardingAPI.sendDocuments(prospect, [defaultDocument]).then(function (res) {
                        var data = prospect;
                        data.status = null;
                        data.sub_status = null;

                        res.sent = res.sent || [];
                        res.sent[0] = res.sent[0] || {};

                        self.hide({statusCode: 'RESEND_I9', data: data, i9NewDoc: res.sent[0]});
                        delete self.sending;
                        $scope.$digest();
                    },
                    function (err) {

                        self.everifyUtils.handleEVerifyErrorMessages(err, function () {
                            delete self.sending;
                            console.error("An Error with Doc Action API:", err);
                            self.hide({statusCode: 'ERROR', data: err});
                        });
                    });
            };

            // init point
            self.$onInit = function () {

                brand = self.modalData.brand;
                application_id = self.modalData.application_id;
                prospect_id = self.modalData.prospect_id;
                job = self.modalData.job;
                defaultDocument = self.modalData.i9DocumentSet;
                document = self.modalData.document;

                // public attribute that available on the scope as startEVerify
                self.user = self.modalData.user;
                self.caseId = self.modalData.everify_case.id;
                self.everifyCase = self.modalData.everify_case;
                self.loading = true;
                self.starting = false;
                self.data = {};

                var afterGetI9Document = function () {
                    if (!document) {
                        var noI9Erorr = new _startEVerifyErrorHandle('No I9 Document Signed Front End Error');

                        hAlert(
                            'Not able to start E-verify',
                            'Something went wrong. There is no I9 send to this candidate before. <br /> For questions you can reach us at 844.HARRI.HELP (844.427.7443).',
                            function () {
                                self.hide({statusCode: 'ERROR', data: noI9Erorr});
                            },
                            'vis-error-alert'
                        );

                        throw noI9Erorr;
                    }

                    EVerifyAPI.getLatestEmployerPhoneNumber(brand.id)
                        .then(function (res) {
                            self.phoneNumber = res.phone_number;
                        })
                        .catch(function (err) {
                            console.error(err);
                        });

                    OnBoardingAPI.checkEVerifyStatus(brand.id, self.user.id, document.id)
                        .then(function (CHECK_E_VERIFY) {
                            self.everifyStartStatus = CHECK_E_VERIFY || {};

                            var handleLoadingLogic = function () {
                                delete self.loading;
                                $scope.$digest();
                            };

                            _handleStartSectionsChange()
                                .then(function () {
                                    handleLoadingLogic();
                                }, function () {
                                    handleLoadingLogic();
                                });
                        }, function (err) {
                            self.everifyUtils.handleEVerifyErrorMessages(err, function () {
                                delete self.loading;
                                self.hide({statusCode: 'ERROR', data: err});
                            });
                        });
                };

                if (!defaultDocument) {
                    OnBoardingAPI.listDocuments(application_id, prospect_id, 'ON_BOARDING', null, true, null, OnBoardingAPI.DOCUMENT_TYPE.I9)
                        .then(function (DOCUMENT_LIST) {
                            var documentList = DOCUMENT_LIST;

                            defaultDocument = {
                                DocumentSet: documentList[0].DocumentSet,
                                code: OnBoardingAPI.DOCUMENT_TYPE.I9,
                                name: OnBoardingAPI.DOC_TYPE_TEXT.I9,
                                type: "DOCUMENT"
                            };

                            document = documentList[0].Document;

                            afterGetI9Document();
                        }, function (err) {
                            delete self.loading;
                            $scope.$digest();
                        });
                } else {
                    afterGetI9Document();
                }
            };
        }]
    };

    angular.module('harriApp.eVerify')
        .component('startEVerify', StartEVerifyComponent);

})();
